import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { forwardRef, memo } from 'react';
import { StyledRootScrollbar, StyledScrollbar } from './styles';
import type { ScrollbarProps } from './types';

const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  (
    {
      children,
      sx,
      className,
      rootSx,
      classNames,
      onReachBottom,
      onScroll,
      ...other
    },
    ref
  ) => {
    const userAgent =
      typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );

    if (isMobile) {
      return (
        <Box
          ref={ref}
          sx={{ overflow: 'auto', ...sx }}
          onScroll={onScroll}
          {...other}
        >
          {children}
        </Box>
      );
    }

    return (
      <StyledRootScrollbar
        sx={rootSx}
        className={classnames('Scrollbar', className)}
      >
        <StyledScrollbar
          scrollableNodeProps={{
            ref,
          }}
          clickOnTrack={false}
          sx={sx}
          classNames={classNames}
          {...other}
          onWheel={onScroll}
        >
          {children}
        </StyledScrollbar>
      </StyledRootScrollbar>
    );
  }
);

export default memo(Scrollbar);
